import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M15 9l-3 3l-3 -3","key":"svg-0"}],["path",{"d":"M15 13l-3 3l-3 -3","key":"svg-1"}],["path",{"d":"M12 3c7.2 0 9 1.8 9 9s-1.8 9 -9 9s-9 -1.8 -9 -9s1.8 -9 9 -9z","key":"svg-2"}]]

const IconSquareRoundedChevronsDown = createReactComponent('outline', 'square-rounded-chevrons-down', 'SquareRoundedChevronsDown', __iconNode);

export default IconSquareRoundedChevronsDown;